module.exports = __webpack_public_path__ + "static/media/ValueReadyDeployment.3b66dee8.svg";